// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__19wVE","gfeWrapper":"CalendarEvent_gfeWrapper__oW3DE"};